// extracted by mini-css-extract-plugin
export var pillWrapper = "_n9-0";
export var showOverflow = "_n9-1";